// @flow
import update from 'immutability-helper';

export type AlertType = 'success' | 'error';

type AlertAction = {
  +type: string;
  +id?: string;
  +alertType?: AlertType;
  +message?: string;
  +messageIntl?: string;
};

export type AlertState = {
  +id?: string;
  +alertType?: AlertType;
  +open?: boolean;
  +message?: string;
  +messageIntl?: string;
};

// Actions
const ALERT_RESET_STATE = 'ALERT_RESET_STATE';
const ALERT_RESET_ERROR_STATE = 'ALERT_RESET_ERROR_STATE';
const ALERT_UNSET_ALERT = 'ALERT_UNSET_ALERT';
const ALERT_CLOSE_ALERT = 'ALERT_CLOSE_ALERT';
const ALERT_SET_NEW_ALERT = 'ALERT_SET_NEW_ALERT';

// Action Creators
export function resetAlertState(): AlertAction {
  return {
    type: ALERT_RESET_STATE,
  };
}

export function resetAlertErrorState(): AlertAction {
  return {
    type: ALERT_RESET_ERROR_STATE,
  };
}

export function unsetAlert(id: string): AlertAction {
  return {
    type: ALERT_UNSET_ALERT,
    id,
  };
}

export function closeAlert(id: string): AlertAction {
  return {
    type: ALERT_CLOSE_ALERT,
    id,
  };
}

export function setNewAlert(id: string, alertType: AlertType,
                            message?: string, messageIntl?: string): AlertAction {
  return {
    type: ALERT_SET_NEW_ALERT,
    id,
    alertType,
    message,
    messageIntl,
  };
}

export const actions = {
  ALERT_RESET_STATE,
  ALERT_RESET_ERROR_STATE,
  ALERT_UNSET_ALERT,
  ALERT_CLOSE_ALERT,
  ALERT_SET_NEW_ALERT,
  resetAlertState,
  resetAlertErrorState,
  unsetAlert,
  closeAlert,
  setNewAlert,
};

export const initialState: AlertState = {};

// Reducer
export default function reducer(state: AlertState = initialState,
                                action: AlertAction): AlertState {
  switch (action.type) {
    case ALERT_UNSET_ALERT:
      // If id is currently showing, then remove it
      // This is to prevent closing when changing screens
      if (action.id === state.id) {
        return initialState;
      }
      return state;
    case ALERT_CLOSE_ALERT:
      if (action.id === state.id) {
        return update(state, { $unset: ['open'] });
      }
      return state;
    case ALERT_SET_NEW_ALERT:
      return {
        id: action.id,
        alertType: action.alertType,
        open: true,
        message: action.message,
        messageIntl: action.messageIntl,
      };
    case ALERT_RESET_STATE:
      return initialState;
    case ALERT_RESET_ERROR_STATE:
      if (state.alertType === 'error') {
        return initialState;
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/alert/duck.js